<template>
  <article class="notification-container">
    <div class="notification-wrap">
      <div class="noti-item">
        <span class="title-box">
          <img src="@/assets/img/deposit.svg" />
          <span class="text">{{ $t("notification.reports.contents.deposit") }}</span>
        </span>
        <router-link :to="{ name: ''}" class="contents-box">
          <span class="text">{{ $t("notification.reports.contents.subTitle.totalList") }}</span>
          <span>(<span>{{pHeadInfo.cashInCnt}}</span>)</span>
        </router-link>
        <router-link :to="{ name: ''}" class="contents-box">
          <span class="text">{{ $t("notification.reports.contents.subTitle.totalAmt") }}</span>
          <span>(<span :class="{ on: pHeadInfo.inAmt !== 0 }">{{ pHeadInfo.cashInAmt }}</span>)</span>
        </router-link>
      </div>
      <div class="noti-item">
        <span class="title-box">
          <img src="@/assets/img/withdraw.svg" />
          <span class="text">{{ $t("notification.reports.contents.withdraw") }}</span>
        </span>
        <router-link :to="{ name: ''}" class="contents-box">
          <span class="text">{{ $t("notification.reports.contents.subTitle.totalList") }}</span>
          <span>(<span>{{pHeadInfo.cashOutCnt}}</span>)</span>
        </router-link>
        <router-link :to="{ name: ''}" class="contents-box">
          <span class="text">{{ $t("notification.reports.contents.subTitle.totalAmt") }}</span>
          <span>(<span :class="{ on: pHeadInfo.outAmt !== 0 }">{{ pHeadInfo.cashOutAmt }}</span>)</span>
        </router-link>
      </div>
      <div class="noti-item">
        <span class="title-box">
          <img src="@/assets/img/pt.svg" />
          <span class="text">알</span>
        </span>
        <router-link :to="{}" class="contents-box">
          <span class="text">생성</span>
          <span>(<span :class="{ on: pHeadInfo.ptAdd !== 0 }">{{ pHeadInfo.ptAdd }}</span>)</span>
        </router-link>
        <router-link :to="{}" class="contents-box">
          <span class="text">환전</span>
           <span>(<span :class="{ on: pHeadInfo.ptChange !== 0 }">{{ pHeadInfo.ptChange }}</span>)</span>
        </router-link>
        <router-link :to="{}" class="contents-box">
          <span class="text">지급신청</span>
          <span>(<span :class="{ on: pHeadInfo.ptAdd !== 0 }">{{ pHeadInfo.ptAddApply }}</span>)</span>
        </router-link>
        <router-link :to="{}" class="contents-box">
          <span class="text">환전신청</span>
           <span>(<span :class="{ on: pHeadInfo.ptChange !== 0 }">{{ pHeadInfo.ptChangeApply }}</span>)</span>
        </router-link>
      </div>
      <div class="noti-item">
        <span class="title-box">
          <img src="@/assets/img/summary_white.svg" />
          <span class="text">{{ $t("notification.reports.contents.reports") }}</span>
        </span>
        <router-link :to="{}" class="contents-box">
          <span class="text">{{ $t("notification.reports.contents.subTitle.totalBalance") }}</span>
          <span>(<span :class="{ on: pHeadInfo.allAmt !== 0 }">{{ pHeadInfo.allAmt }}</span>)</span>
        </router-link>
        <router-link :to="{}" class="contents-box">
          <span class="text">{{ $t("notification.reports.contents.subTitle.daysBalance") }}</span>
          <span>(<span :class="{ on: pHeadInfo.yallAmt !== 0 }">{{ pHeadInfo.yallAmt }}</span>)</span>
        </router-link>
        <router-link :to="{}" class="contents-box">
          <span class="text">{{ $t("notification.reports.contents.subTitle.profit") }}</span>
          <span>(<span :class="{ on: pHeadInfo.beneAmt !== 0 }">{{ pHeadInfo.beneAmt }}</span>)</span>
        </router-link>
      </div>
    </div>
  </article>
</template>
<script>
export default {
  name: "Notification",
  props:['pHeadInfo'],
  data() {
    return {
      notis: this.$i18n,
      cashData: {}
    };
  },
  methods: {},
  created() {}
};
</script>

<style scoped>
.notification-container {
  display: flex;
  align-items: center;
  width: 100%;
}
.credit-wrap {
  width: 220px;
  display: flex;
  justify-content: space-between;
  padding: 0 20px;
  box-sizing: border-box;
}
.credit-wrap .title {
  font-weight: 800;
  color: #ffe000;
}
.credit-wrap .content-val {
  font-weight: 800;
  color: #feb869;
}
.notification-wrap {
  font-size: 11px;
  width:100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.noti-item {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 0 8px;
    border-radius: 6px;
    margin-right: 3px;
    color:#fff;
    font-size:14px;
    font-weight: 500;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}
.noti-item:last-child{
  margin-right:0;
  background: var(--subMain);
}
.noti-item:last-child span span {
  color: #fff;
}
.noti-item:last-child .title-box{
  background:transparent;
}
.noti-item .text {
  font-weight: 600;
  margin-right: 2px;
}
.noti-item:last-child .contents-box {
  color: #fff;
}
.title-box {
  height:28px;
  width:64px;
  font-size:14px;
  display:flex;
  font-weight: 700;
  justify-content: center;
  align-items: center;
  margin-right: 4px;
  background: #fff;
  border-radius: 5px;
  color: #126ae2;
}
.title-box > img{
  margin-right:5px;
}
.contents-box {
  height: 20px;
  border-radius: 10px;
  padding: 0 6px;
  display: flex;
  font-size:14px;
  font-weight: 500;
  justify-content: center;
  align-items: center;
  margin-right: 4px;
  color: #fff;
}
.contents-box:last-child {
  margin: 0;
}

.contents-box span span {
  color: #fff;
  font-weight: bold;
}
.content-mono {
  margin-right: 4px;
}
a {
  color: #fff;
}
a:hover {
  /* font-weight: 800; */
}
</style>
